import React from "react";
const MobilePagination = ({
  currentPage,
  totalPages,
  onPreviousClick,
  onNextClick
}) => {
  return <div className="px-sm-5 pb-lg-0 pb-md-0 pb-xl-0 pb-sm-5" data-sentry-component="MobilePagination" data-sentry-source-file="MobilePagination.jsx">
      <hr className="d-sm-none d-block" style={{
      borderTop: "1px solid #344054",
      margin: "0"
    }} />
      <div className="pagination-container d-flex justify-content-between d-sm-none">
        {/* Previous Button */}
        <button className="page-btn" onClick={onPreviousClick} disabled={currentPage === 1}>
          <span className="arrow">
            <img src="https://d2nnrpx7gk2my2.cloudfront.net/files/6706dac9c123ed0008d60774/arrow-left.svg" alt="Previous" />
          </span>
        </button>

        {/* Current Page Info */}
        <span className="page-info">
          Page {currentPage} of {totalPages}
        </span>

        {/* Next Button */}
        <button className="page-btn" onClick={onNextClick} disabled={currentPage === totalPages}>
          <span className="arrow">
            <img src="https://d2nnrpx7gk2my2.cloudfront.net/files/6706db14c123ed0008d60776/arrow-right.svg" alt="Next" />
          </span>
        </button>

        <style jsx>{`
          .pagination-container {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px 0px;
          }

          .page-btn {
            border: 1px solid #D0D5DD;
            background-color: white;
            color: #4f4f4f;
            font-size: 18px;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 4px;
            cursor: pointer;
            transition: background-color 0.3s;
          }

          .page-btn:disabled {
            cursor: not-allowed;
          }

          .page-btn:hover:not(:disabled) {
            background-color: #f5f5f5;
          }

          .arrow {
            font-size: 24px;
          }
          button:focus{
            box-shadow: 0 0 0 !important;
          }

          .page-info {
            font-size: 14px;
            color: #344054;
            margin: 0 20px;
            font-weight: 400;
          }
        `}</style>
      </div>
    </div>;
};
export default MobilePagination;